import { Online } from 'front-end-core/services/WindowService'
import { Api } from 'front-end-core/core/Api'
import {
  CurrentAwareness,
  CurrentAwarenessPrepay,
  CurrentAwarenessArticle,
  CurrentAwarenessSearch,
  CurrentAwarenessSearchPrepay,
  Guides,
  FeaturedGuides,
  PublishedCaKeyPicks,
  HomePageArticles,
  HomePageArticleSingle,
  HomePageArticleSinglePrepay
} from 'requests/ca'
import {
  LegislationAct,
  LegislationActs,
  LegislationFolders,
  LegislationReference,
  LegislationRelatedQas,
  LegislationSearch,
  LegislationSearchPrepay,
  TakeoverCode,
  TakeoverCodeVersions
} from 'requests/legislation'
import {
  ClarilisDocs,
  ClarilisDocsPrePay,
  ClarilisLink,
  ClarilisLinkPrePay,
  Metadata,
  MetadataPrepay,
  MetadataSearch,
  MetadataSearchPrepay,
  DocDrafterAutomatedListings,
  GetInterviewPreview,
  GetPreviewList,
  InterviewTemplates,
  Interview,
  StaticDocuments,
  DownloadInterview,
  InterviewMetdata,
  SavedInterview,
  DocDrafterAutomatedListingsPrepay,
  PrecedentSections,
  PrecedentSectionsPrepay
} from 'requests/metadata'
import {
  QAContent,
  QAContentPrepay,
  QAInstantSearch,
  QAQuestions,
  QAQuestionsPrepay,
  QAReferences,
  QASearch,
  QASearchPrepay,
  QASections,
  QASectionsPrepay
} from 'requests/qa'
import { CryptoKeyList, User, Users, UserAuth, SearchHistory, Tracking } from 'requests/session'
import {
  EventTypes,
  FeaturedDeal,
  StatsSummary,
  LatestDeals,
  EventConfiguration,
  SharedEventsConfiguration,
  ListDeals,
  Stats,
  Deal
} from 'requests/dealwatch'
import fcObserveRequest from 'helpers/fcObserveRequest'

/* eslint-disable */
const ApiStorage = new Api([
  CurrentAwareness,
  CurrentAwarenessPrepay,
  CurrentAwarenessArticle,
  CurrentAwarenessSearch,
  CurrentAwarenessSearchPrepay,
  Guides,
  FeaturedGuides,
  PublishedCaKeyPicks,
  HomePageArticles,
  HomePageArticleSingle,
  HomePageArticleSinglePrepay,
  LegislationAct,
  LegislationActs,
  LegislationFolders,
  LegislationReference,
  LegislationRelatedQas,
  LegislationSearch,
  LegislationSearchPrepay,
  TakeoverCode,
  TakeoverCodeVersions,
  Metadata,
  MetadataPrepay,
  MetadataSearch,
  MetadataSearchPrepay,
  PrecedentSections,
  PrecedentSectionsPrepay,
  DocDrafterAutomatedListings,
  DocDrafterAutomatedListingsPrepay,
  GetInterviewPreview,
  GetPreviewList,
  QAContent,
  QAContentPrepay,
  QAInstantSearch,
  QAQuestions,
  QAQuestionsPrepay,
  QAReferences,
  QASearch,
  QASearchPrepay,
  QASections,
  QASectionsPrepay,
  CryptoKeyList,
  User,
  Users,
  UserAuth,
  SearchHistory,
  Tracking,
  ClarilisDocs,
  ClarilisDocsPrePay,
  ClarilisLink,
  ClarilisLinkPrePay,
  EventTypes,
  FeaturedDeal,
  StatsSummary,
  LatestDeals,
  EventConfiguration,
  SharedEventsConfiguration,
  ListDeals,
  Stats,
  Deal,
  InterviewTemplates,
  Interview,
  StaticDocuments,
  DownloadInterview,
  InterviewMetdata,
  SavedInterview
], { Online, observeRequest: fcObserveRequest })
/* eslint-enable */

export const fetch = ApiStorage.fetch
export const refresh = ApiStorage.refresh
export const observe = ApiStorage.observe
